import links from "@/links/links";

export default {
  actions: {
    FETCH(agencyId) {
      return this.get(links.TAG_FETCH(), {
        dataKey: "hydra:member",
      });
    },
    GET(id) {
      return this.get(links.TAG_GET(id));
    },
    // NOTE: create + attach to current resolution catalog
    POST(item) {
      return this.post(links.TAG_POST(), item);
    },
    PUT(item) {
      return this.put(links.TAG_PUT(item.id), item);
    },
    DELETE(item) {
      return this.delete(links.TAG_DELETE(item.id), {
        delete: item.id,
      });
    },
  },
};
